import './App.less'
import { QueryClientProvider } from 'react-query'
import { AuthProvider } from './providers/auth.provider'
import AppRoutes from './routes'
import { queryClient } from './config/react-query'
import { I18nextProvider } from 'react-i18next'
import i18n from './config/translation'
import { createStore, Provider } from 'jotai'
import AppWrapper from './components/AppWrapper/AppWrapper'
import { MsalProvider } from '@azure/msal-react'

import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fontsource/open-sans'
import '@fontsource/open-sans/500.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/open-sans/800.css'
import 'animate.css'

import ChartDataLabels from 'chartjs-plugin-datalabels'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement,
  ArcElement,
  ScatterController,
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import msalInstance from './config/msal.config'
// import { ConfigProvider } from 'antd'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  Filler,
  BarElement,
  ArcElement,
  annotationPlugin,
  ScatterController
)

export const store = createStore()

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <I18nextProvider i18n={i18n}>
            <AuthProvider>
              <AppWrapper>
                <AppRoutes />
              </AppWrapper>
            </AuthProvider>
          </I18nextProvider>
        </QueryClientProvider>
      </Provider>
    </MsalProvider>
  )
}

export default App
